import React from "react";
import { useState } from "react";
import imageUrl from "utils/imageUrl";

function DocsSubmit({ onButtonClick }) {
   const [filePaySlip, setfilePaySlip] = useState(null);
   const [fileEpf, setFileEpf] = useState(null);
   const [fileBank, setFileBank] = useState(null);
   const [fileIncome, setFileIncom] = useState(null);

   // const [kycValue, setKycValue] = useState({

   // })
   console.log(filePaySlip, "payslip");
   console.log(fileEpf, "epf");
   console.log(fileBank, "bank");
   console.log(fileIncome, "income");
   //  const handleChange = (event) => {
   //    console.log(event.target.files[0]);
   //    //  setFileEpf(event.target.files[0]);
   //  };

   return (
     <div>
       {" "}
       <h5 className="mt-5">Documents Submission</h5>
       <form action="#" name="save__from" method="post" className="save__form">
         <div className="row my-3">
           <div className="col-sm-6">
             <div className="idcard">
               <p>3 months Payslip </p>
               <div className="inner-id-card d-flex mt-3 mb-5">
                 <div className="upload d-flex flex-column align-items-center">
                   <label
                     htmlFor="pay-slip"
                     className="d-flex flex-column align-items-center"
                   >
                     {" "}
                     <i className="fa-solid fa-upload"></i> <span>Upload</span>
                   </label>
                   <input
                     type="file"
                     name="doc"
                     id="pay-slip"
                     className="d-none"
                     onChange={(e) => setfilePaySlip(e.target.files[0])}
                   />
                 </div>
                 <div className="delete mx-5 d-flex flex-column align-items-center">
                   <i className="fa-solid fa-trash"></i> <span>Delete</span>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-sm-6">
             <div className="id-img">
               <img
                 src={imageUrl("pdf.png")}
                 width={"20%"}
                 alt={filePaySlip === null ? "" : filePaySlip.name}
               />
               <p>{filePaySlip === null ? "" : filePaySlip.name}</p>
             </div>
           </div>
         </div>

         <div className="row my-3">
           <div className="col-sm-6">
             <div className="idcard">
               <p>EPF Statement (2022) </p>
               <div className="inner-id-card d-flex mt-3 mb-5">
                 <div className="upload d-flex flex-column align-items-center">
                   <label
                     htmlFor="epf"
                     className="d-flex flex-column align-items-center"
                   >
                     {" "}
                     <i className="fa-solid fa-upload"></i> <span>Upload</span>
                   </label>
                   <input
                     type="file"
                     name="doc1"
                     id="epf"
                     className="d-none"
                     onChange={(e) => setFileEpf(e.target.files[0])}
                   />
                 </div>
                 <div className="delete mx-5 d-flex flex-column align-items-center">
                   <i className="fa-solid fa-trash"></i> <span>Delete</span>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-sm-6">
             <div className="id-img">
               <img src={imageUrl("pdf.png")} width={"20%"} alt="" />
               <p>{fileEpf === null ? "" : fileEpf.name}</p>
             </div>
           </div>
         </div>

         <div className="row my-3">
           <div className="col-sm-6">
             <div className="idcard">
               <p>Bank Statements </p>
               <div className="inner-id-card d-flex mt-3 mb-5">
                 <div className="upload d-flex flex-column align-items-center">
                   <label
                     htmlFor="bank"
                     className="d-flex flex-column align-items-center"
                   >
                     {" "}
                     <i className="fa-solid fa-upload"></i> <span>Upload</span>
                   </label>
                   <input
                     type="file"
                     name="doc2"
                     id="bank"
                     className="d-none"
                     onChange={(e) => setFileBank(e.target.files[0])}
                   />
                 </div>
                 <div className="delete mx-5 d-flex flex-column align-items-center">
                   <i className="fa-solid fa-trash"></i> <span>Delete</span>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-sm-6">
             <div className="id-img">
               <img src={imageUrl("pdf.png")} width={"20%"} alt="" />
               <p>{fileBank === null ? "" : fileBank.name}</p>
             </div>
           </div>
         </div>

         <div className="row my-3">
           <div className="col-sm-6">
             <div className="idcard">
               <p>Income Tax Statements</p>
               <div className="inner-id-card d-flex mt-3 mb-5">
                 <div className="upload d-flex flex-column align-items-center">
                   <label
                     htmlFor="income-tax"
                     className="d-flex flex-column align-items-center"
                   >
                     {" "}
                     <i className="fa-solid fa-upload"></i> <span>Upload</span>
                   </label>
                   <input
                     type="file"
                     name="doc3"
                     id="income-tax"
                     className="d-none"
                     onChange={(e) => setFileIncom(e.target.files[0])}
                   />
                 </div>
                 <div className="delete mx-5 d-flex flex-column align-items-center">
                   <i className="fa-solid fa-trash"></i> <span>Delete</span>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-sm-6">
             <div className="id-img">
               <img src={imageUrl("pdf.png")} width={"20%"} alt="" />
               <p>{fileIncome === null ? "" : fileIncome.name}</p>
             </div>
           </div>
         </div>
         <div className="row">
           <div className="col-sm-6">
             <div className="confirm-radio-btn d-flex align-items-center">
               <input type="radio" id="sell" name="sell" value={"confirm"} />

               <span className="mx-3">
                 I confirm that the information provided in this form is true
                 and accurate
               </span>
             </div>
           </div>
         </div>
         <div>
           <button
             type="submit"
             className="button button--effect"
             onClick={() => onButtonClick("pagethree")}
           >
             Next
           </button>
         </div>
       </form>
     </div>
   );
}

export default DocsSubmit;
